module.exports = __webpack_public_path__ + "img/L_304_362.16fa9985.png";